export default __webpack_public_path__ + "static/bg-feature-a6c5c7deae776b090cf02273d807c2fd.png";